module.exports = __webpack_public_path__ + "img/fundo.a08811fb.png";